import { COLUMN_TYPES } from "../../constants/common";

const ActionColumnsAdmin = [
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: false,
    width: 190,
    rightPadding: 0,
    isFixed: true,
  },
];

export const DefaultDataColumns = [
  {
    fieldName: "userId",
    label: "USER ID",
    exportLabel: "",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.CHECKBOX,
    showInSelection: false,
  },
  {
    fieldName: "firstName",
    label: "First Name",
    exportLabel: "First Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "lastName",
    label: "Last Name",
    exportLabel: "Last Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "email",
    label: "Email",
    exportLabel: "Email",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.EMAIL,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "roles",
    label: "Roles",
    exportLabel: "Roles",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "annualRevenueText",
    label: "Annual Revenue",
    exportLabel: "Annual Revenue",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingAddressLine1",
    label: "Billing Address 1",
    exportLabel: "Billing Address 1",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingAddressLine2",
    label: "Billing Address 2",
    exportLabel: "Billing Address 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingContact",
    label: "Billing First Name",
    exportLabel: "Billing First Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingContactLastName",
    label: "Billing Last Name",
    exportLabel: "Billing Last Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingPhoneNumber",
    label: "Billing Phone Number",
    exportLabel: "Billing Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "businessName",
    label: "Business Name",
    exportLabel: "Business Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "businessYear",
    label: "Business Year",
    exportLabel: "Business Year",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "mobile",
    label: "Mobile",
    exportLabel: "Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "mobile1",
    label: "Alternate Mobile",
    exportLabel: "Alternate Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax",
    label: "Fax",
    exportLabel: "Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax1",
    label: "Alternate Fax",
    exportLabel: "Alternate Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfEmployees",
    label: "Number of Employees",
    exportLabel: "Number of Employees",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfOwners",
    label: "Number of Owners",
    exportLabel: "Number of Owners",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "phoneNumber",
    label: "Business Phone Number",
    exportLabel: "Business Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 250,
  },
  {
    fieldName: "secondaryPhoneNumber",
    label: "Business Phone Number 2",
    exportLabel: "Business Phone Number 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "producers",
    label: "Producers",
    exportLabel: "Producers",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "secondaryEmail",
    label: "Secondary Email",
    exportLabel: "Secondary Email",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "zipCode",
    label: "Billing Zip Code",
    exportLabel: "Billing Zip Code",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "city",
    label: "Billing City",
    exportLabel: "Billing City",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "state",
    label: "Billing State",
    exportLabel: "Billing State",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "countryName",
    label: "Billing Country",
    exportLabel: "Billing Country",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "systemGeneratedId",
    label: "System Generated Id",
    exportLabel: "System Generated Id",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "taxID",
    label: "Tax ID",
    exportLabel: "Tax ID",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "websiteUrl",
    label: "Website URL",
    exportLabel: "Website URL",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "areas",
    label: "Areas",
    exportLabel: "Areas",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "carriers",
    label: "Carrier",
    exportLabel: "Carrier",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "carrierRepresents",
    label: "Carrier Represents",
    exportLabel: "Carrier Represents",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "technologies",
    label: "Technologies",
    exportLabel: "Technologies",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "industryGroups",
    label: "Industry Groups",
    exportLabel: "Industry Groups",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
];

export const AdminColumns = [
  {
    fieldName: "userId",
    label: "USER ID",
    exportLabel: "",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.CHECKBOX,
    showInSelection: false,
  },
  {
    fieldName: "firstName",
    label: "First Name",
    exportLabel: "First Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "lastName",
    label: "Last Name",
    exportLabel: "Last Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "email",
    label: "Email",
    exportLabel: "Email",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.EMAIL,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "secondaryEmail",
    label: "Secondary Email",
    exportLabel: "Secondary Email",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "phoneNumber",
    label: "Business Phone Number",
    exportLabel: "Business Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "secondaryPhoneNumber",
    label: "Business Phone Number 2",
    exportLabel: "Business Phone Number 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "mobile",
    label: "Mobile",
    exportLabel: "Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "mobile1",
    label: "Alternate Mobile",
    exportLabel: "Alternate Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax",
    label: "Fax",
    exportLabel: "Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax1",
    label: "Alternate Fax",
    exportLabel: "Alternate Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "roles",
    label: "Roles",
    exportLabel: "Roles",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "systemGeneratedId",
    label: "System Generated Id",
    exportLabel: "System Generated Id",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdOn",
    label: "Sign-up Date",
    exportLabel: "Sign-up Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "isLocked",
    label: "Account Status",
    exportLabel: "Account Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.UNBLOCK_TOGGLE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
  },
  ...ActionColumnsAdmin,
];

export const DistributorColumns = [
  {
    fieldName: "userId",
    label: "USER ID",
    exportLabel: "",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.CHECKBOX,
    showInSelection: false,
  },
  {
    fieldName: "brandName",
    label: "Brand Name",
    exportLabel: "Brand Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },

  {
    fieldName: "firstName",
    label: "First Name",
    exportLabel: "First Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "lastName",
    label: "Last Name",
    exportLabel: "Last Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "email",
    label: "Email",
    exportLabel: "Email",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.EMAIL,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "roles",
    label: "Roles",
    exportLabel: "Roles",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "annualRevenueText",
    label: "Annual Revenue",
    exportLabel: "Annual Revenue",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingAddressLine1",
    label: "Billing Address 1",
    exportLabel: "Billing Address 1",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingAddressLine2",
    label: "Billing Address 2",
    exportLabel: "Billing Address 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingContact",
    label: "Billing First Name",
    exportLabel: "Billing First Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingContactLastName",
    label: "Billing Last Name",
    exportLabel: "Billing Last Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingPhoneNumber",
    label: "Billing Phone Number",
    exportLabel: "Billing Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "businessName",
    label: "Business Name",
    exportLabel: "Business Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "businessYear",
    label: "Business Year",
    exportLabel: "Business Year",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "mobile",
    label: "Mobile",
    exportLabel: "Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "mobile1",
    label: "Alternate Mobile",
    exportLabel: "Alternate Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax",
    label: "Fax",
    exportLabel: "Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax1",
    label: "Alternate Fax",
    exportLabel: "Alternate Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfEmployees",
    label: "Number of Employees",
    exportLabel: "Number of Employees",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfOwners",
    label: "Number of Owners",
    exportLabel: "Number of Owners",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "phoneNumber",
    label: "Business Phone Number",
    exportLabel: "Business Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "secondaryPhoneNumber",
    label: "Business Phone Number 2",
    exportLabel: "Business Phone Number 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "producers",
    label: "Producers",
    exportLabel: "Producers",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "secondaryEmail",
    label: "Secondary Email",
    exportLabel: "Secondary Email",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "zipCode",
    label: "Zip Code",
    exportLabel: "Zip Code",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "city",
    label: "City",
    exportLabel: "City",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "state",
    label: "State",
    exportLabel: "State",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "countryName",
    label: "Country",
    exportLabel: "Country",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "systemGeneratedId",
    label: "System Generated Id",
    exportLabel: "System Generated Id",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "taxID",
    label: "Tax ID",
    exportLabel: "Tax ID",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "websiteUrl",
    label: "Website URL",
    exportLabel: "Website URL",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "areas",
    label: "Areas",
    exportLabel: "Areas",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "carriers",
    label: "Carrier",
    exportLabel: "Carrier",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "carrierRepresents",
    label: "Carrier Represents",
    exportLabel: "Carrier Represents",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "technologies",
    label: "Technologies",
    exportLabel: "Technologies",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "industryGroups",
    label: "Industry Groups",
    exportLabel: "Industry Groups",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "distributorTypes",
    label: "Distributors Types",
    exportLabel: "Distributors Types",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdOn",
    label: "Sign-up Date",
    exportLabel: "Sign-up Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "isLocked",
    label: "Account Status",
    exportLabel: "Account Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.UNBLOCK_TOGGLE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
  },
  ...ActionColumnsAdmin,
];

export const EnterpriseColumns = [
  {
    fieldName: "brandName",
    label: "Brand Name",
    exportLabel: "Brand Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "userId",
    label: "USER ID",
    exportLabel: "",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.CHECKBOX,
    showInSelection: false,
  },
  {
    fieldName: "firstName",
    label: "First Name",
    exportLabel: "First Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "lastName",
    label: "Last Name",
    exportLabel: "Last Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "email",
    label: "Email",
    exportLabel: "Email",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.EMAIL,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "roles",
    label: "Roles",
    exportLabel: "Roles",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "annualRevenueText",
    label: "Annual Revenue",
    exportLabel: "Annual Revenue",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingAddressLine1",
    label: "Billing Address 1",
    exportLabel: "Billing Address 1",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "billingAddressLine2",
    label: "Billing Address 2",
    exportLabel: "Billing Address 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "billingContact",
    label: "Billing First Name",
    exportLabel: "Billing First Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingContactLastName",
    label: "Billing Last Name",
    exportLabel: "Billing Last Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "billingPhoneNumber",
    label: "Billing Phone Number",
    exportLabel: "Billing Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "businessName",
    label: "Business Name",
    exportLabel: "Business Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "businessYear",
    label: "Business Year",
    exportLabel: "Business Year",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "mobile",
    label: "Mobile",
    exportLabel: "Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "mobile1",
    label: "Alternate Mobile",
    exportLabel: "Alternate Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax",
    label: "Fax",
    exportLabel: "Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "fax1",
    label: "Alternate Fax",
    exportLabel: "Alternate Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfEmployees",
    label: "Number of Employees",
    exportLabel: "Number of Employees",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfOwners",
    label: "Number of Owners",
    exportLabel: "Number of Owners",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "phoneNumber",
    label: "Business Phone Number",
    exportLabel: "Business Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "secondaryPhoneNumber",
    label: "Business Phone Number 2",
    exportLabel: "Business Phone Number 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "producers",
    label: "Producers",
    exportLabel: "Producers",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "secondaryEmail",
    label: "Secondary Email",
    exportLabel: "Secondary Email",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "zipCode",
    label: "Zip Code",
    exportLabel: "Zip Code",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "city",
    label: "City",
    exportLabel: "City",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "state",
    label: "State",
    exportLabel: "State",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "countryName",
    label: "Country",
    exportLabel: "Country",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "systemGeneratedId",
    label: "System Generated Id",
    exportLabel: "System Generated Id",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "taxID",
    label: "Tax ID",
    exportLabel: "Tax ID",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "websiteUrl",
    label: "Website URL",
    exportLabel: "Website URL",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "areas",
    label: "Areas",
    exportLabel: "Areas",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "carrierRepresents",
    label: "Carrier Represents",
    exportLabel: "Carrier Represents",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "technologies",
    label: "Technologies",
    exportLabel: "Technologies",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "industryGroups",
    label: "Industry Groups",
    exportLabel: "Industry Groups",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "enterpriseTypes",
    label: "Enterprise Types",
    exportLabel: "Enterprise Types",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdOn",
    label: "Sign-up Date",
    exportLabel: "Sign-up Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "isLocked",
    label: "Account Status",
    exportLabel: "Account Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.UNBLOCK_TOGGLE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
  },
  ...ActionColumnsAdmin,
];

const distributorNameColumn = {
  fieldName: "distributorName",
  label: "Distributor",
  exportLabel: "Distributor",
  sort: false,
  isSelected: false,
  type: COLUMN_TYPES.HIGHLIGHT_FILTER_VALUE,
  showInSelection: true,
  width: 250,
};

const businessYearIndex = DefaultDataColumns.findIndex(
  (c) => c.fieldName === "businessYear",
);

export const SubscriberColumns = [
  ...DefaultDataColumns.slice(0, businessYearIndex + 1),
  distributorNameColumn,
  ...DefaultDataColumns.slice(businessYearIndex + 1),
  {
    fieldName: "isLocked",
    label: "Account Status",
    exportLabel: "Account Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.UNBLOCK_TOGGLE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "subscriberTypes",
    label: "Subscriber Types",
    exportLabel: "Subscriber Types",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "migrationStatus",
    label: "Migration Status",
    exportLabel: "Migration Status",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.MIGRATION_STATUS,
    activeLabelText: "Completed",
    inactiveLabelText: "Incomplete",
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "shippingAddressLine1",
    label: "Shipping Address Line 1",
    exportLabel: "Shipping Address Line 1",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "shippingAddressLine2",
    label: "Shipping Address Line 2",
    exportLabel: "Shipping Address Line 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "shippingContactName",
    label: "Shipping First Name",
    exportLabel: "Shipping First Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 250,
  },
  {
    fieldName: "shippingContactLastName",
    label: "Shipping Last Name",
    exportLabel: "Shipping Last Name",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 250,
  },
  {
    fieldName: "shippingPhoneNumber",
    label: "Shipping Phone Number",
    exportLabel: "Shipping Phone Number",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 250,
  },
  {
    fieldName: "shippingZipCode",
    label: "Shipping Zip Code",
    exportLabel: "Shipping Zip Code",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "shippingCity",
    label: "Shipping City",
    exportLabel: "Shipping City",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "shippingStateName",
    label: "Shipping State",
    exportLabel: "Shipping State",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "shippingCountryName",
    label: "Shipping Country",
    exportLabel: "Shipping Country",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdOn",
    label: "Sign-up Date",
    exportLabel: "Sign-up Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "associatedStatus",
    label: "Associate Status",
    exportLabel: "Associate Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
  },
  ...ActionColumnsAdmin,
];

export const DistributorInternalUserColumns = [...AdminColumns];

export const EnterpriseInternalUserColumns = [...AdminColumns];

export const ManageDocumentsListColumns = [
  {
    fieldName: "fileName",
    label: "File Name",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.ACTIVE_INACTIVE_LABEL,
    showInSelection: false,
  },
  {
    fieldName: "userDocumentId",
    label: "Doc ID",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "createdOn",
    label: "Created On",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.DATE,
    showInSelection: false,
  },
  {
    fieldName: "uploadedBy",
    label: "Uploaded By",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: true,
    isFixed: true,
    rightPadding: 0,
    options: [
      {
        label: "Delete",
        testId: "delete",
        status: "publishStatus",
        iconPath: "/images/delete_disable.png",
        iconPathInactive: "/images/delete_enable.png",
        disabled: false,
        testIdText: "DeleteIcon",
        activeTitle: "Delete Content",
        deactiveTitle: "Published content cannot be deleted",
      },
    ],
    width: 60,
  },
];
export const ManageDocumentsSuccessOrErrorListColumns = [
  {
    fieldName: "fileName",
    label: "File Name",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.ACTIVE_INACTIVE_LABEL,
    showInSelection: false,
  },
  {
    fieldName: "userDocumentId",
    label: "Doc ID",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "createdOn",
    label: "Created On",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.DATE,
    showInSelection: false,
  },
  {
    fieldName: "uploadedBy",
    label: "Uploaded By",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "massUploadedBy",
    label: "Mass Uploaded by",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: true,
    isFixed: true,
    rightPadding: 0,
    options: [
      {
        label: "Delete",
        testId: "delete",
        status: "publishStatus",
        iconPath: "/images/delete_disable.png",
        iconPathInactive: "/images/delete_enable.png",
        disabled: false,
        testIdText: "DeleteIcon",
        activeTitle: "Delete Content",
        deactiveTitle: "Published content cannot be deleted",
      },
    ],
    width: 60,
  },
];

export const EGRenewalHistoryColumns = [
  {
    fieldName: "distributorBrandName",
    label: "Distributor Brand Name",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 200,
  },
  {
    fieldName: "associationId",
    label: "Membership/Acc number",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 250,
  },
  {
    fieldName: "subscriptionName",
    label: "Subscription Type",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 150,
  },
  {
    fieldName: "frequencyText",
    label: "Frequency",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "startDate",
    label: "Start Date",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.DATE,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "expirationDate",
    label: "Expiration Date",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.DATE,
    showInSelection: false,
    width: 150,
  },
  {
    fieldName: "subscriptionFees",
    label: "Subscription Amount",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 200,
  },
  {
    fieldName: "isRecurring",
    label: "Auto Renewal",
    exportLabel: "",
    sort: false,
    isSelected: true,
    YesLabelText: "Yes",
    NoLabelText: "No",
    type: COLUMN_TYPES.BOOLEAN,
    showInSelection: false,
    width: 150,
  },
  {
    fieldName: "statusText",
    label: "Status",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
];

export const SubscriberRenewalHistoryColumns = [
  {
    fieldName: "brandName",
    label: "Enterprise Name",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "subscriptionName",
    label: "Subscription Type",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "frequencyText",
    label: "Frequency",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "isRecurring",
    label: "Recurring",
    exportLabel: "",
    sort: false,
    isSelected: true,
    YesLabelText: "Yes",
    NoLabelText: "No",
    type: COLUMN_TYPES.BOOLEAN,
    showInSelection: false,
  },
  {
    fieldName: "subscriptionFees",
    label: "Subscription Fees",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
  },
  {
    fieldName: "startDate",
    label: "Start Date",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.DATE,
    showInSelection: false,
  },
  {
    fieldName: "endDate",
    label: "End Date",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.DATE,
    showInSelection: false,
  },
];

export const ErrorRecordsColumns = [
  {
    fieldName: "errors",
    label: "Errors",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 200,
  },
  {
    fieldName: "uploadedFileName",
    label: "Uploaded File Name",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 220,
  },
  {
    fieldName: "typeOfContent",
    label: "Type of Content",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "contentName",
    label: "Content Name",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "typesOfForms",
    label: "Types of Forms",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "lob",
    label: "LOB",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "country",
    label: "Country",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "state",
    label: "State/Province",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 120,
  },
  {
    fieldName: "latestVersion",
    label: "Edition Date",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "searchKeywords",
    label: "Search Keywords",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "tags",
    label: "Content Tags/Labels",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "fillable",
    label: "Fillable",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "fileName",
    label: "FileName",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 200,
  },
  {
    fieldName: "availableToPublic",
    label: "Available to Public",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "displayToPublic",
    label: "Display to Public",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "isPreviewAvailable",
    label: "Is Preview Available",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "previewAvailable",
    label: "Preview Available",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "webLink",
    label: "Web Link",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "marketingDescription",
    label: "Marketing Description",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 200,
  },
  {
    fieldName: "contentType",
    label: "Content Type(Free/Paid)",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 280,
  },
  {
    fieldName: "oneTimeCost",
    label: "One Time Cost",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "subscriptionsType",
    label: "Subscriptions Type",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 120,
  },
  {
    fieldName: "baseValue",
    label: "Base Value",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "frequency",
    label: "Frequency",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "recurringType",
    label: "Recurring Type",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
  {
    fieldName: "publish",
    label: "Publish",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 100,
  },
];

export const SubscriberAccessDataColumns = [
  {
    fieldName: "userName",
    label: "Distributor Brand Name",
    exportLabel: "Distributor Brand Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "formNumber",
    label: "Form Number",
    exportLabel: "Form Number",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "name",
    label: "Content/Catalog/Bundle Name",
    exportLabel: "Content/Catalog/Bundle Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 250,
  },
  {
    fieldName: "latestVersion",
    label: "Edition Date",
    exportLabel: "Edition Date",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
];

export const listOfVendorDataColumn = [
  {
    fieldName: "name",
    label: "Vendor Name",
    exportLabel: "Vendor Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "email",
    label: "Primary Email Address",
    exportLabel: "Primary Email Address",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.EMAIL,
    showInSelection: true,
    width: 288,
    rightPadding: 10,
  },
  {
    fieldName: "secondaryEmail",
    label: "Secondary Email Address",
    exportLabel: "Secondary Email Address",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.EMAIL,
    showInSelection: true,
    width: 288,
    rightPadding: 10,
  },
  {
    fieldName: "phoneNumber",
    label: "Phone Number",
    exportLabel: "Phone Number",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "billingAddressLine1",
    label: "Billing Address 1",
    exportLabel: "Billing Address 1",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "billingAddressLine2",
    label: "Billing Address 2",
    exportLabel: "Billing Address 2",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "zipCode",
    label: "Zip Code",
    exportLabel: "Zip Code",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "city",
    label: "City",
    exportLabel: "City",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "state",
    label: "State",
    exportLabel: "State",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "countryName",
    label: "Country",
    exportLabel: "Country",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdOn",
    label: "Created Date",
    exportLabel: "Created Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdByName",
    label: "Created By",
    exportLabel: "Created By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedOn",
    label: "Last Updated Date",
    exportLabel: "Last Updated Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedByName",
    label: "Last Updated By",
    exportLabel: "Last Updated By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    isFixed: true,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
    rightPadding: 190,
  },
  ...ActionColumnsAdmin,
];
export const VendorContactsColumns = [
  {
    fieldName: "firstName",
    label: "First Name",
    exportLabel: "First Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "lastName",
    label: "Last Name",
    exportLabel: "Last Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "email",
    label: "Email Address",
    exportLabel: "Email Address",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.EMAIL,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "phoneNumber",
    label: "Phone Number",
    exportLabel: "Phone Number",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 180,
  },
  {
    fieldName: "mobile",
    label: "Mobile",
    exportLabel: "Mobile",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 180,
  },
  {
    fieldName: "fax",
    label: "Fax",
    exportLabel: "Fax",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 180,
  },
  {
    fieldName: "createdOn",
    label: "Created Date",
    exportLabel: "Created Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdByName",
    label: "Created By",
    exportLabel: "Created By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedOn",
    label: "Last Updated Date",
    exportLabel: "Last Updated Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedByName",
    label: "Last Updated By",
    exportLabel: "Last Updated By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    isFixed: true,
    width: 150,
  },
  ...ActionColumnsAdmin,
];
export const SolutionDetailsColumns = [
  {
    fieldName: "name",
    label: "Solution Name",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "description",
    label: "Description",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.DESCRIPTION,
    showInSelection: true,
    width: 660,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    showInSelection: true,
    width: 100,
  },
  ...ActionColumnsAdmin,
];
export const VendorServiceDetailsColumns = [
  {
    fieldName: "serviceName",
    label: "Service Name",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 220,
  },
  {
    fieldName: "integrationMethodText",
    label: "Integration Method",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 220,
  },
  {
    fieldName: "integrationTypeText",
    label: "Integration Type",
    exportLabel: "",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 220,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    showInSelection: false,
    width: 220,
  },
  ...ActionColumnsAdmin,
];
export const listofAddInsServicesDataColumns = [
  {
    fieldName: "name",
    label: "Add-ins Name",
    exportLabel: "Add-ins Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "vendorName",
    label: "Vendor",
    exportLabel: "Vendor",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "addInTypeText",
    label: "Add-ins Type",
    exportLabel: "Add-ins Type",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "costTypeText",
    label: "Cost Type",
    exportLabel: "Cost Type",
    sort: true,
    sortBy: "costType",
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 160,
  },
  {
    fieldName: "publishStatusText",
    label: "Published",
    exportLabel: "Published",
    sort: true,
    sortBy: "publishStatus",
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 140,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    isFixed: true,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
    rightPadding: 190,
  },
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: false,
    width: 190,
    rightPadding: 0,
    isFixed: true,
    options: [
      {
        label: "Delete",
        testId: "delete",
        status: "publishStatus",
        iconPath: "/images/delete_disable.png",
        iconPathInactive: "/images/delete_enable.png",
        disabled: false,
        testIdText: "DeleteIcon",
        activeTitle: "Delete Add-in",
        deactiveTitle: "Published add-ins cannot be deleted",
      },
      {
        label: "Copy",
        testId: "copy",
        iconPath: "/images/copy-icon.png",
        iconPathInactive: "/images/copy-icon.png",
        disabled: false,
        testIdText: "CopyIcon",
        activeTitle: "Copy Add-in",
        deactiveTitle: "Copy Add-in",
      },
    ],
  },
];

export const listofAddInsEnterpriseDataColumns = [
  {
    fieldName: "name",
    label: "Add-ins Name",
    exportLabel: "Add-ins Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "vendorName",
    label: "Vendor",
    exportLabel: "Vendor",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "addInTypeText",
    label: "Add-ins Type",
    exportLabel: "Add-ins Type",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "costTypeText",
    label: "Cost Type",
    exportLabel: "Cost Type",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 160,
  },
  {
    fieldName: "hasAdminAccess",
    label: "Access",
    exportLabel: "Access",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    activeLabelText: "Yes",
    inactiveLabelText: "No",
    showInSelection: true,
    width: 140,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 160,
  },
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: false,
    width: 90,
    rightPadding: 0,
    isFixed: true,
    options: [],
  },
];
export const listofDistributorAddInsServicesColumns = [
  {
    fieldName: "name",
    label: "Name",
    exportLabel: "Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "integrationSolutionName",
    label: "Associated Integration",
    exportLabel: "Associated Integration",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 288,
    rightPadding: 10,
  },
  {
    fieldName: "addInDescription",
    label: "Description",
    exportLabel: "Description",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 288,
    rightPadding: 10,
  },
  {
    fieldName: "addInTypeText",
    label: "Type",
    exportLabel: "Type",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "applicableToText",
    label: "Applicable To",
    exportLabel: "Applicable To",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "restrictToText",
    label: "Restrict To",
    exportLabel: "Restrict To",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "costTypeText",
    label: "Type(Free/Paid)",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: false,
    width: 280,
  },
  {
    fieldName: "publishStatusText",
    label: "Published",
    exportLabel: "Published",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 120,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    isFixed: true,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
    rightPadding: 190,
  },
  ...ActionColumnsAdmin,
];

export const AdManagementColumns = [
  {
    fieldName: "bannerName",
    label: "Banner Name",
    exportLabel: "Banner Name",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "position",
    label: "Position",
    exportLabel: "Position",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "dateRange",
    label: "Date Range",
    exportLabel: "Date Range",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },
  {
    fieldName: "payment",
    label: "Payment",
    exportLabel: "Payment",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    isFixed: true,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    showInSelection: true,
    width: 150,
    rightPadding: 190,
  },
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: false,
    width: 190,
    rightPadding: 0,
    isFixed: true,
    options: [
      {
        label: "Copy",
        testId: "copy",
        iconPath: "/images/copy-icon.png",
        iconPathInactive: "/images/copy-icon.png",
        disabled: false,
        testIdText: "CopyIcon",
        activeTitle: "Copy Ad",
        deactiveTitle: "Copy Ad",
      },
      {
        label: "Delete",
        testId: "delete",
        status: "status",
        iconPath: "/images/delete_disable.png",
        iconPathInactive: "/images/delete_enable.png",
        disabled: false,
        testIdText: "DeleteIcon",
        activeTitle: "Delete Ad",
        deactiveTitle: "Delete Ad",
      },
    ],
  },
];
